import React, { useState, FunctionComponent, useEffect } from "react"

interface CheckboxProps {
	title: string
	name: string
	checked: boolean
	handleChange: (ev: React.ChangeEvent<HTMLInputElement>) => any
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ title, name, checked, handleChange }) => {
	const [value, setValue] = useState(checked)

	useEffect(() => {
		setValue(checked)
	}, [checked])

	return (
		<div className='checkbox-wrapper'>
			<label htmlFor={name}>{title}</label>
			<input type='checkbox' name={name} checked={value} onChange={(e) => handleChange(e)} />
		</div>
	)
}

export default Checkbox
